<template name="Guide">
  <div class="page-guide">
    <Top :isDetailPage="false" :trainingId="routeId" @changeVisitListStatus="inviteListShow = true"></Top>
    <main>
      <div class="close-guide">
        <router-link :to="'/external/detailIndex/'+ this.routeId +'/0'">
          <i class="iconfont icon-close"></i>
        </router-link>
      </div>
      <div class="container guide-container" v-html="guideHtml">
      </div>
    </main>
    <footerMenuExternal :trainingId="routeId" :isContactSelectShow="false" :isDetailPage="false" @changeVisitListStatus="inviteListShow = true"></footerMenuExternal>
    <footerExternal :isLoginPage="false"></footerExternal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script>

import Top from '@/views/external/top.vue';
import footerExternal from '@/components/footerExternal.vue';
import footerMenuExternal from '@/components/footerMenuExternal.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { getExternalHelpContent } from '@/utils/api';
import { checkNested } from '@/utils/utils';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import Vue from 'vue';
import $ from 'jquery';

const options = {
  fullscreenEl: false,
  escKey: true,
  clickToCloseNonZoomable: true,
};
Vue.use(preview, options);

export default {
  name: 'Guide',
  components: {
    Top,
    footerExternal,
    footerMenuExternal,
    Loading,
  },
  data() {
    return {
      inviteListShow: false,
      isLoading: false,
      routeId: 0,
      guideHtml: '',
    };
  },
  watch: {
    guideHtml(val) {
      if (val) {
        this.$nextTick(() => {
          //Do jQuery stuff here
          $('.guide-container').on('click', '.step-name, .iconfont', function () {
            $(this).parent().find('.iconfont').toggleClass('icon-up').next('.guide-content-detail').slideToggle();
          });
          this.$previewRefresh();
          $('.guide-content-detail-item').each(function(i, ele) {
            $(ele).find('img.mobile').attr('preview', i + '' + i);
            $(ele).find('img.desktop').attr('preview', i + '' + (i + 1));
          });
        });
      }
    },
  },
  created() {
    const routeID = this.$route.params.id;
    console.log(routeID);
    this.routeId = routeID;

    getExternalHelpContent().then((res) => {
      if (checkNested(res, 'data', 'content', 'model')) {
        this.guideHtml = res.data.content.model;
      }
    });
  },
  mounted() {
  },
};
</script>
<style lang="scss">
.close-guide {
  float: right;
  position: relative;
  right: 8%;
  margin-top: 2%;
  a {
    color: #4a4a4a;
  }
}
.page-guide {
  .detail-header .row .header-right .two-link .guide {
    position: relative;
    &:after {
      content: '';
      width: 100%;
      height: 3px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: #e42029;
    }
    span,
    i {
      color: #e42029;
    }
  }
}
</style>
<style lang="scss">
  @import '../../scss/variables.scss';
  .guide-container {
    width: 85%;
    padding: 20px 0 80px 0;
    .guide-item {
      h3 {
        color: #4a4a4a;
        font-size: 18px;
        font-weight: bold;
      }
      .guide-content {
        border-radius: 4px;
        padding: 15px 15px 15px 45px;
        box-shadow: 0 0 15px rgba(100,100,100,.2);
        background: url(../../assets/images/external/mail.png) no-repeat left 15px center;
        background-size: 20px auto;
        color: #4a4a4a;
        font-size: 13px;
        margin-top: 10px;
        position: relative;
        &.guide-content-contact {
          @include respond-to('lg') {
            max-width: 380px;
          }
        }
        &.guide-content-operation {
          padding-top: 24px;
          padding-bottom: 24px;
          padding: 24px 15px 24px 0;
          background: url(../../assets/images/external/question.png) no-repeat left 15px top 25px;
          background-size: 20px auto;
          font-size: 15px;
          .step-name {
            font-weight: bold;
            margin-bottom: 0;
            padding-left: 45px;
            padding-top: 2px;
          }
          .iconfont {
            position: absolute;
            right: 20px;
            top: 26px;
            font-size: 10px;
          }
          .guide-content-detail {
            // margin-top: 20px;
            display: none;
            .guide-content-detail-item {
              margin-top: 10px;
              font-size: 12px;
              padding-left: 45px;
              background: url(../../assets/images/external/red-mark.png) no-repeat left 15px top 0;
              background-size: 20px;
              &.map-detail-item {
                padding-left: 10px;
                background: none;
                img.mobile {
                  width: 100%;
                }
              }
              h4 {
                font-size: 13px;
                font-weight: bold;
                padding-top: 3px;
              }
              img {
                &.mobile, &.desktop {
                  margin-right: 20px;
                  width: calc(50% - 18px);
                  &:nth-of-type(2n + 2) {
                    margin-right: 0;
                  }
                }
                &.desktop {
                  display: none;
                }
                @include respond-to('lg') {
                  &.mobile {
                    display: none;
                  }
                  &.desktop {
                    display: inline;
                  }
                }
              }
            }
          }
        }
      }
      &.operation-item {
        margin-top: 30px;
      }
    }
  }
</style>
